import { render, staticRenderFns } from "./FormRO03.vue?vue&type=template&id=bf889cfc"
import script from "./FormRO03.vue?vue&type=script&lang=js"
export * from "./FormRO03.vue?vue&type=script&lang=js"
import style0 from "./FormRO03.vue?vue&type=style&index=0&id=bf889cfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports